export var NAME = "name";
export var EMAIL = "email";
export var MESSAGE = "message";
